<template>
  <div class="tw-flex tw-flex-col tw-items-end tw-justify-center">
    <div v-if="column.expensesAmount && column.expensesAmount > 0" class="tw-flex tw-items-center tw-gap-1">
      <WdsText size="sm" weight="medium">{{ column.currency }}</WdsText>
      <WdsText size="sm" weight="medium">{{ formattedExpenses }}</WdsText>
    </div>
    <WdsText v-else size="sm" weight="medium">-</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestExpensesColumn = graphql(`
  fragment PaymentRequestExpensesColumn on PaymentRequest {
    id
    currency
    expensesAmount
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestExpensesColumn>
}>()

const column = computed(() => useFragment(PaymentRequestExpensesColumn, props.row))

const formattedExpenses = computed(() => {
  if (!column.value.expensesAmount) return '0'
  return column.value.expensesAmount.toString()
})
</script>

<style scoped></style> 